import FastFoodIcon from "@mui/icons-material/Fastfood";
import PadlockIcon from '@mui/icons-material/Https';
import GamingIcon from '@mui/icons-material/SportsEsports';
import AIIcon from '@mui/icons-material/AutoAwesome';
import BankIcon from '@mui/icons-material/AccountBalance';
import CarIcon from '@mui/icons-material/DirectionsCar';
import CardIcon from '@mui/icons-material/Payment';
import ClothesIcon from '@mui/icons-material/Checkroom';
import CommunicationIcon from '@mui/icons-material/LocalPhone';
import EmailIcon from '@mui/icons-material/Email';
import GovernmentIcon from '@mui/icons-material/Gavel';
import HealthcareIcon from '@mui/icons-material/HeartBroken';
import HouseIcon from '@mui/icons-material/Home';
import InsuranceIcon from '@mui/icons-material/DoneAll';
import JosephIcon from '@mui/icons-material/Crib';
import MediaIcon from '@mui/icons-material/MusicNote';
import OnlineIcon from '@mui/icons-material/CellWifi';
import ParkingIcon from '@mui/icons-material/LocalParking';
import PensionIcon from '@mui/icons-material/MonetizationOn';
import ProgrammingIcon from '@mui/icons-material/Terminal';
import RandomIcon from '@mui/icons-material/Casino';
import ServerIcon from '@mui/icons-material/Dns';
import ShoppingIcon from '@mui/icons-material/ShoppingCart';
import SportsIcon from '@mui/icons-material/SportsCricket';
import TravelIcon from '@mui/icons-material/FlightTakeoff';
import UncategorizedIcon from '@mui/icons-material/DeviceUnknown';
import UtilitiesIcon from '@mui/icons-material/EvStation';
import PetsIcon from '@mui/icons-material/Pets';
import WifiIcon from '@mui/icons-material/SignalWifi3BarLock';
import PersonIcon from "@mui/icons-material/Person";
import NetworkIcon from '@mui/icons-material/Lan';

interface AccountCategoryImageProps {
    category: string;
}

export const AccountCategoryImage = ({category}: AccountCategoryImageProps) => {
    const lowerCategory = category.toLowerCase();
    const props = {
        className: "group-glyph",
    };
    const primaryColour = "#1976d2";
    switch (lowerCategory) {
        case "ai":
            return <AIIcon {...props}/>;
        case "bank":
        case "banking":
            return <BankIcon {...props} style={{color: "#888"}}/>;
        case "car":
            return <CarIcon {...props}/>;
        case "card":
        case "cards":
            return <CardIcon {...props} style={{color: primaryColour}}/>;
        case "clothes":
        case "clothing":
            return <ClothesIcon {...props}/>;
        case "phone":
        case "communication":
            return <CommunicationIcon {...props}/>;
        case "email":
            return <EmailIcon {...props}/>;
        case "food":
            return <FastFoodIcon {...props}/>;
        case "games":
        case "gaming":
            return <GamingIcon {...props}/>;
        case "government":
            return <GovernmentIcon {...props}/>;
        case "health":
        case "healthcare":
            return <HealthcareIcon {...props} style={{color: "#AA0000"}}/>;
        case "house":
            return <HouseIcon {...props}/>;
        case "insurance":
            return <InsuranceIcon {...props} style={{color: "#008800"}}/>;
        case "joseph":
            return <JosephIcon {...props}/>;
        case "jp":
            return <BankIcon {...props}/>;
        case "media":
            return <MediaIcon {...props}/>;
        case "millennium":
            return <BankIcon {...props} style={{color: primaryColour}}/>;
        case "nene":
            return <PersonIcon {...props}/>;
        case "network":
        case "networking":
            return <NetworkIcon {...props}/>;
        case "online":
            return <OnlineIcon {...props}/>;
        case "parking":
            return <ParkingIcon {...props} style={{color: primaryColour}}/>;
        case "pension":
            return <PensionIcon {...props} style={{color: "#008800"}}/>;
        case "development":
        case "programming":
            return <ProgrammingIcon {...props}/>;
        case "random":
            return <RandomIcon {...props}/>;
        case "server":
            return <ServerIcon {...props}/>;
        case "shopping":
            return <ShoppingIcon {...props}/>;
        case "sports":
            return <SportsIcon {...props}/>;
        case "travel":
            return <TravelIcon {...props}/>;
        case "uncategorized":
            return <UncategorizedIcon {...props}/>;
        case "utilities":
            return <UtilitiesIcon {...props} style={{color: "#dd5"}}/>;
        case "vet":
        case "pets":
            return <PetsIcon {...props} style={{color: "#925e45"}}/>;
        case "wifi":
        case "wireless":
            return <WifiIcon {...props} style={{color: "#98bcd1"}}/>;
    }
    return <PadlockIcon {...props} style={{color: "#888"}}/>;
}
